import React, { useEffect } from "react";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { useDispatch } from "react-redux";
import findUsers from "../../store/users/actions/findUsers";
import { findMessages } from "../../store/users/actions/findMessages";
import { ActivitySection } from "./components/ActivitySection";
import { UsersKpis } from "./components/UsersKpis";

export const RRHH: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(findUsers());
    dispatch(findMessages());
  }, [dispatch]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light"></IonMenuButton>
          </IonButtons>
          <IonTitle>RRHH</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">RRHH</IonTitle>
          </IonToolbar>
        </IonHeader>

        <section className={isPlatform("desktop") ? "ion-padding" : ""}>
          <UsersKpis />
          <ActivitySection />
        </section>
      </IonContent>
    </IonPage>
  );
};
